import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { CONSTANTS } from 'config/constants';
import { SampleType } from 'models/order';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const { SAMPLE_METHODS } = CONSTANTS;

type SampleDropdownProps = {
    sample: SampleType;
    onSampleChange: (sample: SampleType) => void;
};

export const SampleDropdown: FC<SampleDropdownProps> = ({ sample, onSampleChange }) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    return (
        <FormControl fullWidth>
            <InputLabel id="sample-select-label">{translate('orders:SAMPLE')}</InputLabel>
            <Select
                value={sample || SampleType.ALL}
                onChange={(event: SelectChangeEvent) => onSampleChange(event.target?.value as SampleType)}
                labelId="sample-select-label"
                label={translate('orders:SAMPLE')}
            >
                <MenuItem value="ALL">{translate('common:ALL')}</MenuItem>
                {SAMPLE_METHODS.map((method, index) => {
                    return (
                        <MenuItem key={index} value={method}>
                            {translate(method)}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};
